import { render, staticRenderFns } from "./AtomSelectPrimary.vue?vue&type=template&id=90b4da62"
import script from "./AtomSelectPrimary.vue?vue&type=script&lang=js"
export * from "./AtomSelectPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports